import { Spinner } from '@cian/ui-kit';
import { IconActionList16 } from '@cian/ui-kit-design-tokens/icons';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';
import { ControlLinkButton } from '../../ControlLinkButton';

interface IListingButtonProps {
  url: string;
  onClick(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void;
  text: string;
  loading?: boolean;
  isMobile: boolean;
}

export function ListingButton({ url, onClick, text, loading, isMobile }: IListingButtonProps) {
  return (
    <ControlLinkButton
      href={url}
      className={cx(styles['navigation-btn'], styles['listing-btn'], isMobile && styles['listing-btn--mobile'])}
      onClick={onClick}
      size={isMobile ? 'L' : 'M'}
    >
      {loading ? (
        <div className={styles['loader']}>
          <Spinner size={16} />
        </div>
      ) : (
        <>
          <IconActionList16 color="icon-primary-default" />
          <span className={cx(styles['listing-title'], isMobile && styles['listing-title--mobile'])}>{text}</span>
        </>
      )}
    </ControlLinkButton>
  );
}
